module.exports = __webpack_public_path__ + "static/media/machine-photo.8739321c.png";